/**
 * `/auth/change-password` — the one screen a session opened with a temporary
 * password from HR can use.
 *
 * Outside `_auth`: the restricted token opens nothing but the password change,
 * refresh and logout, so the shell (and its data) must not load. The layout
 * is passive for the same reason: no branding call.
 *
 * Guard: no session → login; a session that isn't restricted → the app home.
 */
import type { JSX } from "react";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { AuthLayout, ChangePasswordForm, useAuthBranding } from "@linkhr/auth/pages";
import { env } from "../env";

export const Route = createFileRoute("/auth/change-password")({
  beforeLoad: ({ context }) => {
    const snap = context.auth.getSnapshot();
    if (!snap.isAuthenticated) throw redirect({ to: "/login", replace: true });
    if (snap.mustChangePassword !== true) throw redirect({ to: "/", replace: true });
  },
  component: ChangePasswordRouteComponent,
});

function ChangePasswordRouteComponent(): JSX.Element {
  const navigate = useNavigate();
  const branding = useAuthBranding("", { passive: true });
  return (
    <AuthLayout branding={branding}>
      <ChangePasswordForm
        apiBaseUrl={env.VITE_API_BASE_URL}
        onDone={() => {
          void navigate({ to: "/", replace: true });
        }}
      />
    </AuthLayout>
  );
}
